module.exports = __webpack_public_path__ + "static/img/content-img-1.228da091.jpg";